import { render, staticRenderFns } from "./adminAdHocModels.vue?vue&type=template&id=c364a38c&scoped=true&"
import script from "./adminAdHocModels.vue?vue&type=script&lang=js&"
export * from "./adminAdHocModels.vue?vue&type=script&lang=js&"
import style0 from "./adminAdHocModels.vue?vue&type=style&index=0&id=c364a38c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c364a38c",
  null
  
)

export default component.exports